import { render, staticRenderFns } from "./Painting.vue?vue&type=template&id=3eaaafdd&"
import script from "./Painting.vue?vue&type=script&lang=js&"
export * from "./Painting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports